import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { managerFeedbackReducer } from './manager-feedback.reducer';
import { ManagerFeedbackEffects } from './manager-feedback.effects';

/**
 * Manager Feedback State Module
 *
 * Registers the manager feedback feature state with NgRx.
 * Import this module in StateModule to activate manager feedback state management.
 */
@NgModule({
  imports: [
    StoreModule.forFeature('managerFeedback', managerFeedbackReducer),
    EffectsModule.forFeature([ManagerFeedbackEffects])
  ]
})
export class ManagerFeedbackStateModule {}
